<mat-checkbox
  *ngIf="hasKeep"
  id="{{fieldId}}"
  [checked]="keepObj.canKeep"
  (change)="toggleKeep()"></mat-checkbox>
